<div class="errorPage-container d-flex flex-column">
    <div class="error-page">
        <img class="error-page-image" alt="Page not found" src="/assets/images/error-pages/error-page-not-found.svg" />
        <div class="error-page-content">
            <h1 translate="PAGE_NOT_FOUND_TITLE"></h1>
            <p translate="PAGE_NOT_FOUND_TEXT"></p>
        </div>
    </div>
    <div class="d-flex w-100 justify-content-center">
        <button class="btn btn-primary m-3" translate="RETURN_TO_PREVIOUS_STEP" (click)="retry()"></button>
        <button class="btn btn-secondary m-3" translate="RETURN_TO_EMPLOYEE_STEP" (click)="returnToStepOne()"></button>
    </div>
</div>
